export default __webpack_public_path__ + "static/media/1.ab2ee42b.jpg";